const COLOURS = {
  primary: {
    black: "#000000",
    white: "#FFFFFF",
  },
  secondary: {
    orange: "#FF5B00",
    green: "#1A9839",
    aqua: "#15E2D6",
  },
  tertiary: {
    orange: "#FF6200",
    green: "#87EA5C",
  },
};

const BORDERS = {
  primary: "rgba(255, 255, 255, 1)",
  secondary: "rgba(0, 0, 0, 1)",
  tertiary: "rgba(0, 0, 0, 0.1)",
};

export { COLOURS, BORDERS };
